<template>
    <div class="betgameEditPoints" id="betgameEditPoints">
        
        <NavigationBar>
            <template v-slot:left>
                <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
            </template>
            <template v-slot:center>
              {{ $t('betgame_settings.betgame_evaluation_method') }}
            </template>
            <template v-slot:right>
              <div v-if="betmode === 1" v-on:click="openHelp"><HintIcon class="navigation_icon"></HintIcon></div>
            </template>
        </NavigationBar>

        <ul class="error-container">
            <li v-for="error in errors">{{ error }}</li>
        </ul>
        
        <form @submit.prevent="changeBetgamePoints">
            
            <div class="input-container">
                
                <div>

                    <div class="input-header">
                      {{ $t('betgame_settings.betgame_evaluation_method') }}
                    </div>

                    <div class="input-infotext">
                      {{ $t('betgame_settings.betgame_evaluation_method_text_1') }}<br>{{ $t('betgame_settings.betgame_evaluation_method_text_2') }}
                    </div>

                    <div v-if="betmode === 1" class="input-stepper">
                        <div @click="pointsBetResultUp" class="input-stepper-button input-stepper-button-up"></div>
                        <input id="points1" max="99" min="0" :disabled="hasSeasonStarted"
                               step="1" placeholder="-" type="number" v-model="betgame.points_bet_result">
                        <div @click="pointsBetResultDown" class="input-stepper-button input-stepper-button-down"></div>
                        <label for="points1">{{ $t('betgame_settings.bet_exact_match_result') }}</label>
                    </div>

                    <div v-if="betmode === 1" class="input-stepper">
                        <div @click="pointsBetGoaldiffUp" class="input-stepper-button input-stepper-button-up"></div>
                        <input id="points2" max="99" min="0" :disabled="hasSeasonStarted"
                               step="1" placeholder="-" type="number" v-model="betgame.points_bet_goaldiff">
                        <div @click="pointsBetGoaldiffDown" class="input-stepper-button input-stepper-button-down"></div>
                        <label for="points2">{{ $t('betgame_settings.bet_goal_difference') }}</label>
                    </div>

                    <div v-if="betmode === 1" class="input-stepper">
                        <div @click="pointsBetTendencyUp" class="input-stepper-button input-stepper-button-up"></div>
                        <input id="points3" max="99" min="0" :disabled="hasSeasonStarted"
                               step="1" placeholder="-" type="number" v-model="betgame.points_bet_tendency">
                        <div @click="pointsBetTendencyDown" class="input-stepper-button input-stepper-button-down"></div>
                        <label for="points3">{{ $t('betgame_settings.bet_tendency') }}</label>
                    </div>

                    <div v-if="betmode === 2" class="input-stepper">
                      <div @click="pointsBetResultUp" class="input-stepper-button input-stepper-button-up"></div>
                      <input id="points4" max="99" min="0" :disabled="hasSeasonStarted"
                             step="1" placeholder="-" type="number" v-model="betgame.points_bet_result">
                      <div @click="pointsBetResultDown" class="input-stepper-button input-stepper-button-down"></div>
                      <label for="points4">{{ $t('points') }}</label>
                    </div>
                  
                </div>
                
                <div v-if="!hasSeasonStarted" class="input-button-row">
                    <button name="button" type="submit">
                      {{ $t('button_save_text') }}
                    </button>
                </div>
            
            </div>
        
        </form>
    
        <modal class="modal" name="edit-points-help" id="edit-points-help" :scrollable="true" width="100%" height="auto">
          <div class="modal-header">
            <div class="modal-header-left"></div>
            <div class="modal-header-center">{{ $t('betgame_settings.betgame_evaluation_method_examples') }}</div>
            <div class="modal-header-right">
              <button
                type="button"
                class="btn-close"
                @click="$modal.hide('edit-points-help')"
                aria-label="Close modal">
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="table-view">
              <div class="table-view-title">
                {{ $t('betgame_settings.bet_exact_match_result') }}
              </div>
              <div class="table-view-cell grouped">
                <div class="table-view-cell-label">
                  {{ $t('betgame_settings.bet_exact_match_result_example') }}
                </div>
              </div>
              <div class="table-view-title">
                {{ $t('betgame_settings.bet_goal_difference') }}
              </div>
              <div class="table-view-cell grouped">
                <div class="table-view-cell-label">
                  {{ $t('betgame_settings.bet_goal_difference_example') }}
                </div>
              </div>
              <div class="table-view-title">
                {{ $t('betgame_settings.bet_tendency') }}
              </div>
              <div class="table-view-cell grouped">
                <div class="table-view-cell-label">
                  {{ $t('betgame_settings.bet_tendency_example') }}
                </div>
              </div>
              <div class="table-view-title">
                {{ $t('betgame_settings.bet_no_points') }}
              </div>
              <div class="table-view-cell grouped">
                <div class="table-view-cell-label">
                  {{ $t('betgame_settings.bet_no_points_example') }}
                </div>
              </div>
            </div>
          </div>
        </modal>
        
    </div>
    
    <!--<div class="notification">
        <h1>Exaktes Ergebnis</h1>
        <p>Beispiel: Spiel endet 3:1 und der Tipp lautet 3:1</p>
        <h1>Tordifferenz</h1>
        <p>Beispiel: Spiel endet 3:1 und der Tipp lautet 2:0 oder 4:2</p>
        <h1>Ergebnis</h1>
        <p>Beispiel: Spiel endet 3:1 und der Tipp lautet 2:1 oder 1:0</p>
        <h1>Keine Punkte</h1>
        <p>Beispiel: Spiel endet 3:1 und der Tipp lautet 1:1 oder 0:2</p>
    </div>-->

    
</template>

<script>
  
  import NavigationBar from './../components/NavigationBar'
  import { TOAST_DURATION } from '../main'
  import HintIcon from './../components/icons/HintIcon'
  
  export default {
    name: 'BetgameEditPoints',
    components: { HintIcon, NavigationBar },
    data () {
      return {
        betgame: null,
        errors: []
      }
    },
    created () {
      this.betgame = this.$route.params.betgame
    },
    mounted () {
      if (this.betgame === null || this.betgame === undefined) {
        this.goBack()
      };
    },
    computed: {
      betmode() {
        return this.$store.state.betgame.bet_mode || 1
      }
    },
    methods: {
      openHelp() {
        this.$modal.show('edit-points-help');
      },
      pointsBetGoaldiffUp() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_goaldiff < 100) {
          this.betgame.points_bet_goaldiff += 1
        } else {
          this.betgame.points_bet_goaldiff = 0
        }
      },
      pointsBetGoaldiffDown() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_goaldiff > 0) {
          this.betgame.points_bet_goaldiff -= 1
        }
      },
      pointsBetResultUp() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_result < 100) {
          this.betgame.points_bet_result += 1
        } else {
          this.betgame.points_bet_result = 0
        }
      },
      pointsBetResultDown() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_result > 0) {
          this.betgame.points_bet_result -= 1
        }
      },
      pointsBetTendencyUp() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_tendency < 100) {
          this.betgame.points_bet_tendency += 1
        } else {
          this.betgame.points_bet_tendency = 0
        }
      },
      pointsBetTendencyDown() {
        if(this.hasSeasonStarted()) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.change_evaluation_method_error'), position: 'top', duration: TOAST_DURATION, type: 'error'})
          return
        }
        if(this.betgame.points_bet_tendency > 0) {
          this.betgame.points_bet_tendency -= 1
        }
      },
      updateBetgame (data) {
        this.$store.dispatch('patchBetgame', data)
        .then(() => {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.save_changes_success'),
            position: 'top',
            duration: TOAST_DURATION,
            type: 'success'
          })
          this.goBack()
        })
        .catch(function (error) {
          this.$toast.open({ message: this.$i18n.t('betgame_settings.save_changes_error'),
            position: 'top',
            duration: TOAST_DURATION,
            type: 'error'
          })
        })
        .finally(function () {
        })
      },
      goBack () {
        this.$router.push('/betgameedit')
      },
      changeBetgamePoints () {
        this.errors = []
        if (!this.isNumeric(this.betgame.points_bet_result) || this.betgame.points_bet_result < 0 || this.betgame.points_bet_result > 99) {
          this.errors.push(this.$i18n.t('betgame_settings.change_on_the_nose_points_error'))
        }
        if (!this.isNumeric(this.betgame.points_bet_goaldiff) || this.betgame.points_bet_goaldiff < 0 || this.betgame.points_bet_goaldiff > 99) {
          this.errors.push(this.$i18n.t('betgame_settings.change_goal_difference_points_error'))
        }
        if (!this.isNumeric(this.betgame.points_bet_tendency) || this.betgame.points_bet_tendency < 0 || this.betgame.points_bet_tendency > 99) {
          this.errors.push(this.$i18n.t('betgame_settings.change_outcome_points_error'))
        }
        if (this.errors.length === 0) {
          this.$store.dispatch('setBetgame', this.betgame)
          this.updateBetgame({
            points_bet_result: this.betgame.points_bet_result,
            points_bet_goaldiff: this.betgame.points_bet_goaldiff,
            points_bet_tendency: this.betgame.points_bet_tendency
          })
          
          this.goBack()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .betgameEditPoints {
    
    form {
      padding-top: 16px;
    }
    
    h1 {
      text-align: center;
    }
    
    p {
      text-align: center;
      margin-bottom: 26px;
    }
  }

  .grouped {
    margin-top: -16px;
  }

  .table-view {
    margin-bottom: 0;
  }

  .table-view-cell:last-child {
    border-bottom: 0;
  }

  .table-view-cell-label {
    color: rgba($colorGreyDark, .48);
    font-weight: 400;
  }
</style>
